<template>
  <div class="infoDetailsLeftBox">
    <div class="infoDetailsLeft">
      <div class="infoLeft">

        <p><i class="el-icon-map-location"></i>当前位置<span class="home" @click="handleHome">首页</span><span class="el-icon-d-arrow-right"></span><span>{{infoStr}}</span></p>
          <div v-if="receiveType == 2">
            <el-card class="infoCard">
              <p>{{receiveData.publicityTitle}}</p>
              <div class="time">{{timeStr}}:{{receiveData.createTime}}</div>
              <div class="line"></div>
              <div class="caseNum">{{receiveData.publicityCaseNum}}</div>
              <div class="contentOne" v-html="receiveData.publicityContent?JSON.parse(receiveData.publicityContent).contentOne:''">
         
              </div>
              <el-image :src="$store.state.file_url + item.filePath" v-for="(item,index) in JSON.parse(receiveData.publicityEvidencePic)" :key="index+'a'" class="elImage">
             
              </el-image>
              <div class="contentOne" v-html="receiveData.publicityContent?JSON.parse(receiveData.publicityContent).contentTwo:''">
         
              </div>
              <div class="makingsTitle">
                附件：证明材料
              </div>
              <div class="makingsBox clearfix" v-for="(item, itemIndex) in JSON.parse(receiveData.publicityMaterial)" :key="itemIndex">
                <p class="makingsIndex">链接{{itemIndex+1}}</p>
                <p class="makingsPath" @click="handleOpen($store.state.file_url + item.filePath)">{{handleSubStr(item.filePath)}}</p>
              </div>
              <div class="makingsMsg clearfix">
                <ul>
                  <li>申&nbsp;&nbsp;请&nbsp;&nbsp;人：{{copyrightowner}}</li>
                  <li>联系邮箱：{{email}}</li>
                  <li>联系电话：{{mobile}}</li>
                </ul>
                <ul>
                  <li>申&nbsp;&nbsp;请&nbsp;&nbsp;人：{{copyrightowner2}}</li>
                  <li>联系邮箱：{{email2}}</li>
                  <li>联系电话：{{mobile2}}</li>
                </ul>
              </div>
              <div class="footerStr">公示期：自本公示发布之日其长期有效。</div>
            </el-card>
          </div>
          <div v-else>
            <el-card class="infoCard">
              <p>{{receiveData.newsTitle}}</p>
              <div class="time">{{timeStr}}:{{receiveData.releaseTime}}</div>
              <div class="line"></div>
              <div class="caseNum">{{receiveData.releaseUser}}:{{receiveData.submitterName}}</div>
              <div class="contentOne" v-html="receiveData.content">
         
              </div>
              <!-- <el-image :src="$store.state.file_url + item.filePath" v-for="(item,index) in JSON.parse(receiveData.publicityEvidencePic)" :key="index+'a'" class="elImage">
             
              </el-image> -->
              <!-- <div class="contentOne" v-html="receiveData.publicityContent?JSON.parse(receiveData.publicityContent).contentTwo:''">
         
              </div> -->
              <!-- <div class="makingsTitle">
                附件：证明材料
              </div>
              <div class="makingsBox clearfix" v-for="(item, itemIndex) in JSON.parse(receiveData.publicityMaterial)" :key="itemIndex">
                <p class="makingsIndex">链接{{itemIndex+1}}</p>
                <p class="makingsPath" @click="handleOpen($store.state.file_url + item.filePath)">{{$store.state.file_url + item.filePath}}</p>
              </div>
              <div class="makingsMsg clearfix">
                <ul>
                  <li>申&nbsp;&nbsp;请&nbsp;&nbsp;人：{{copyrightowner}}</li>
                  <li>联系邮箱：{{email}}</li>
                  <li>联系电话：{{mobile}}</li>
                </ul>
                <ul>
                  <li>申&nbsp;&nbsp;请&nbsp;&nbsp;人：{{copyrightowner2}}</li>
                  <li>联系邮箱：{{email2}}</li>
                  <li>联系电话：{{mobile2}}</li>
                </ul>
              </div>
              <div class="footerStr">公示期：自本公示发布之日其长期有效。</div> -->
            </el-card>
          </div>
      </div>
      <infoDetailsRight></infoDetailsRight>
    </div>
  </div>
</template>
<script>
import Bus from '@/js/bus.js'
import infoDetailsRight from './infoDetailsRight.vue';
export default {
  components: {
    infoDetailsRight
  },
  data() {
    return{
      receiveType:'', 
      receiveData:{},
      infoStr:'',
      timeStr:'',
      copyrightowner:'',
      email:'',
      mobile:'',
      copyrightowner2:'',
      email2:'',
      mobile2:''
    }
  },
  created() {
    this.getDetail()
  },
  mounted(){
    let that = this;
    Bus.$on('handleDetails',(id,type)=>{
      Bus.$emit('handleDetailsRight',type)
      that.getDetail(id,type)
    })
  },
  methods:{
    handleSubStr(val){
      let index = val.lastIndexOf('/');
      return val.substr(index+1,val.length)
    },
    handleOpen(url){
      window.open(url);
    },
    getDetail(id,type){
      if(type){
        this.receiveType = type;
      }else{
        this.receiveType = this.$route.query.type;
      }
      let idStr
      if(id){
        idStr = id;
      }else{
        idStr = this.$route.query.id
      }
      if(this.receiveType == 2){
        this.infoStr = '版权公示';
        this.timeStr = '公示时间';
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.8)'
        });
        this.$axiosGet(this.$store.state.asset_public + "/publicity/details", {
          id: idStr,
        }).then(res=>{
          loading.close();
          if(res.code == 200){
            this.receiveData = res.data;
            this.receiveData.publicityRelevantPersonnelList.map((item)=>{
              if(item.identity == "1"){
                this.copyrightowner = item.name?item.name:'';
                this.email = item.email?item.email:'';
                this.mobile = item.mobile?item.mobile:''
              }else if(item.identity == "3"){
                this.copyrightowner2 = item.name;
                this.email2 = item.email?item.email:'';
                this.mobile2 = item.mobile?item.mobile:''
              }
            })
          }
        })
      }else{
        this.infoStr = '最新资讯';
        this.timeStr = '发布时间';
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.8)'
        });
        this.$axiosGet(this.$store.state.assets_url + "/wespace/index/findWorksNewsDetails", {
          id: idStr,
        }).then(res=>{
          loading.close();
          if(res.code == 200){
            this.receiveData = res.data;
          }
        })
      
      }
    },
    handleHome(){
      this.$router.push({
        path:'/'
      })
    },

  }
}
</script>
<style scoped lang="scss">
.clearfix:after{
  display: block;
  clear: both;
  content: '';
  visibility: hidden;
}
.clearfix {
  zoom: 1;
}
.infoDetailsLeftBox{
  background: #fff;
  .infoDetailsLeft{
    width: 1200px;
    margin:  0 auto;
    padding-top: 16px;
    padding-bottom: 40px;
    display: flex;
    justify-content: space-between;
    .infoLeft{
      width: 833px;
      border: 1px solid #F2F2F2;
      padding: 30px;
      p{
        color: #999;
        font-size: 12px;
        span,i:last-child{
          font-weight: 600;
          font-weight: bold;
          color: #181818; 
        }
        span{
          margin-right: 7px;
        }
        .home{
          margin-left: 14px;
          cursor: pointer;
        }
      }
      .infoCard{
        // padding: 14px 13px 14px 10px;
        border:none;
        box-shadow:none;
        border: 1px solid #FFF;
        p{
          font-size: 18px;
          font-weight: 600;
          font-weight: bold;
          color: #000;
          line-height: 25px;
          text-align: center;
          display: -webkit-box;//谷歌
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;//显示几行
          word-wrap:break-word;
          overflow: hidden;
        }
        .time{
          color: #999999;
          font-size: 12px;
          text-align: center;
        }
        .line{
          height: 1px;
          background: #F2F2F2;
          margin: 16px 0 11px 0;
        }
        .caseNum{
          color: #333333;
          font-weight: bold;
          font-weight: 600;
          font-size: 14px;
          text-align: right;
          margin-bottom: 9px;
        }
        .elImage{
          width: 100%;
          margin: 20px 0;
        }
        .makingsTitle{
          font-weight: 600;
          font-weight: bold;
          color: #181818;
          font-size: 14px;
          margin: 20px 0;
        }
        .makingsBox{
          width: 100%;
          p{
            text-align: left;
          }
          .makingsIndex{
            color: #333333;
            font-size: 14px;
            margin-bottom: 6px;
          }
          .makingsPath{
            margin-bottom: 10px;
            color: #666666;
            font-size: 12px;
          }
          .makingsPath:hover{
            color: #1844AE;
            cursor: pointer;
          }
        }
        .makingsMsg{
          ul{
            li{
              padding: 5px 0;
              font-size: 14px;
              color: #333333;
              font-weight: bold;
              font-weight: 600;
            }
          }
        }
        .footerStr{
          text-align: left;
          font-weight: 600;
          font-weight: bold;
          color: #181818;
          font-size: 14px;
        }
        .contentOne{
          color: #333;
          font-size: 14px;
        }
      }
      ::v-deep.el-card__body{
        padding: 0;
      }
    }
    
  }

}
</style>
